var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningWest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5376 0 0 12.5376 0 28C0 43.4624 12.5376 56 28 56C43.4624 56 56 43.4624 56 28C56 12.5376 43.4624 0 28 0Z",
    fill: "#0054A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6703 10.6786L17.4184 12.128C17.4184 12.128 18.5359 18.877 14.1094 24.36V45.3316L27.6772 45.3141V43.5068H14.7642V40.7566H27.651V38.1373H14.7555V35.4046H18.3526V12.7653L21.0766 11.7351V35.3522H27.651V22.5439L21.6616 10.6699L21.6703 10.6786Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3301 10.6786L38.5821 12.128C38.5821 12.128 37.4645 18.877 41.891 24.36V45.3316L28.3232 45.3141V43.5068H41.2362V40.7566H28.3494V38.1373H41.245V35.4046H37.6478V12.7653L34.9238 11.7351V35.3522H28.3494V22.5439L34.3388 10.6699L34.3301 10.6786Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.731 13.1141L28.0615 21.8101L31.8594 13.0879C31.8594 13.0879 27.7122 14.4237 23.731 13.1228V13.1141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWest);
export default __webpack_public_path__ + "static/media/warning_west.08e41ca06afcef0e8334f01d4018254f.svg";
export { ForwardRef as ReactComponent };